var paginationDirectiveTemplate =
  '<nav ng-class=\'{"low-opacity": disabled}\'>' +
    '<ul class="pagination">' +
      '<li class="page-item" ng-repeat="page in getPages() track by $index"' +
          'ng-class=\'{"active": isCurrentPage(page), "disabled": isEllipsis(page)}\'>' +
        '<a class="page-link" ng-if="isEllipsis(page)">&hellip;</a>' +
        '<a class="page-link" ng-if="!isEllipsis(page)" ng-click="changePage(page)">' +
          '{{generateButtonText(page)}}' +
        '</a>'+
      '</li>' +
      '<li class="page-item" ng-class=\'{"disabled": data.page >= data.pageCount()}\'>' +
        '<a class="h-padding-large page-link next-button-link"' +
           'ng-click="changePage(data.page + 1)">' +
          '<b class="h-padding-medium">next</b>' +
        '</a>' +
      '</li>' +
    '</ul>' +
  '</nav>';

angular
  .module('directives.pagination', [])
  .directive('pagination', [
    function() {
      var link = function ($scope) {
        /** Total number of interactive buttons that will display an actual page
         * number (`next` button is not counted here)
         * Representation of the directive:
         *
         * [1]  [...]  [7]  [8 of 10]  [next]
         * */
        var MAX_PAGE_NUMBER_BUTTONS = 3;

        /**
         * Generate the text of the button based on the page
         *
         * @param {number} pageNumber - Integer corresponding to a page number
         * @returns {string} - Text that will be added to button
         */
        $scope.generateButtonText = function(pageNumber) {
          var text = pageNumber;
          if ($scope.isCurrentPage(pageNumber)) {
            text += ' of ' + $scope.data.pageCount();
          }
          return text;
        };

        /**
         * Check if page passed as argument is the same number as current page
         * the user is viewing.
         *
         * @param {(number|string)} page - Can either be a number or 'ellipsis'
         * @returns {boolean}
         */
        $scope.isCurrentPage = function(page) {
          return page === $scope.data.page;
        };

        /**
         * Check if page corresponds to the ellipsis one
         *
         * @param {(number|string)} page - Can either be a number or 'ellipsis'
         * @returns {boolean}
         */
        $scope.isEllipsis = function(page) {
          return page === 'ellipsis';
        };

        /**
         * If current page is superior to 3, so if this function returns true,
         * an ellipsis will appear in the UI
         *
         * @returns {boolean}
         */
        var showEllipsis = function() {
          return $scope.data.page > MAX_PAGE_NUMBER_BUTTONS;
        };

        /**
         * Calculate the number of page buttons will appear in the UI. Note that
         * the "Next" button is excluded from this calculation, as "Next" will
         * always appear. We push the button to the array in the order in which they
         * will be shown.
         *
         * If current page is superior to 3, so if this function returns true,
         * an ellipsis will appear in the UI
         *
         * @returns {Array} visiblePageButtons - Each item will then be used in the
         *                                      view, thanks to the ng-repeat
         * @returns {number} visiblePageButtons[0] - Will always be 1, as
         *                                                 we will always show at least
         *                                                 button [1 of totalPageNumber]
         *
         * @returns {(string|number)} visiblePageButtons[1] - Can either be a number or
         *                                                 'ellipsis'
         */
        $scope.getPages = function() {
          var visiblePageButtons = [1];

          if($scope.data) {
            if($scope.data.page === 1) {
              return visiblePageButtons;
            }

            // Whenever current page number is superior to 3, show an ellipsis
            // Example: current page is 4 and total is 10 (3 is then previous page)
            //  [1]  [...]  [3]  [4 of 10]  [next]
            if(showEllipsis()) {
              visiblePageButtons.push('ellipsis');
            }

            // If page number is superior to 2, show the previous page button
            // Example: current page is 3 and total is 10 (2 is then previous page)
            // [1]  [2]  [3 of 10]  [next]
            if($scope.data.page > 2) {
              visiblePageButtons.push($scope.data.page - 1);
            }

            visiblePageButtons.push($scope.data.page);
            return visiblePageButtons;
          }

        };

        /**
         * Change page of the Pagination object and executes optional callback
         * function.
         *
         * In the case user wants to go to next after exceeding
         * total number of pages OR if input is disabled, disallow page change
         * by returning false
         *
         * @param {number} page - Integer corresponding to a page number
         *
         * @returns {false|number} - False if invalid page, page number if successfully changed
         */
        $scope.changePage = function(page) {
          if(page > $scope.data.pageCount() || $scope.disabled) {
            return false;
          }

          $scope.data.page = page;
          $scope.onPageChange(page);

          return page;
        };
      };

      return {
        restrict: 'E',
        template: paginationDirectiveTemplate,
        scope: {
          data: '=',
          onPageChange: '<',
          disabled:'=ngDisabled'
        },
        link: link
      };
    }
  ]);
